import PropTypes from "prop-types";

import { TreeMapChart } from "components/Chart";
import { Title } from "style/components/Title.styles";
import { NoDataMessage } from "features/Strategy/v2/Detail/StrategyDetails.styles";
import { AssetTradingVolumeChartPlaceholder } from "./AssetTradingVolumeChartPlaceholder";

const AssetTradingVolumeChart = ({ data = [], isLoading, title }) => {
  if (isLoading) {
    return <AssetTradingVolumeChartPlaceholder height="300px" />;
  }

  return (
    <div className="asset-trading-volume-chart">
      <Title className="mb-0">{title ? title : "Asset Trading Volume"}</Title>
      <div className="divider my-3"></div>
      <div className="chart-container">
        {data.length > 0 ? (
          <TreeMapChart data={data} height="300px" />
        ) : (
          <NoDataMessage>No data to display</NoDataMessage>
        )}
      </div>
    </div>
  );
};

AssetTradingVolumeChart.propTypes = {
  data: PropTypes.array,
  isLoading: PropTypes.bool,
  title: PropTypes.string,
};

export { AssetTradingVolumeChart };
